import Image from 'next/image'
import cn from 'classnames'

import CrossIcon from 'images/close-icon-white.png'

import styles from './styles.module.scss'
import { useState } from 'react'

const Banner = ({
    children
}) => {
    const [visible, setVisible] = useState(true)

    const onClose = () => setVisible(false)

    return (
        <section className={cn(styles.container, { [styles.hidden]: !visible })}>
            <div className={styles.wrapper}>
                {children}

                <div className={styles.btn__cross}>
                    <Image
                        src={CrossIcon}
                        width={14}
                        height={14}
                        onClick={onClose}
                    />
                </div>
            </div>
        </section>
    )
}

export default Banner